import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "product-info" }
const _hoisted_2 = { class: "product-shopping" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "product-img" }
const _hoisted_9 = {
  key: 0,
  class: "product-img-box1"
}
const _hoisted_10 = { class: "flex_img" }
const _hoisted_11 = { class: "left-img" }
const _hoisted_12 = { class: "middle-img" }
const _hoisted_13 = { class: "right-img" }
const _hoisted_14 = {
  key: 1,
  class: "product-img-box2"
}
const _hoisted_15 = { class: "flex_img" }
const _hoisted_16 = { class: "left-img" }
const _hoisted_17 = { class: "middle-img" }
const _hoisted_18 = { class: "right-img" }
const _hoisted_19 = {
  key: 2,
  class: "game_img"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "big-title" }, [
      _createElementVNode("span", null, "PRODUCTS")
    ], -1)),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "product-info-text" }, " In the realm of gaming, our quest is to craft innovative, visually captivating and endlessly replayable innovation, where joy and happiness find their eternal abode. ", -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listData, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass([$setup.productIndex === index ? 'active' : '']),
          onClick: ($event: any) => ($setup.handleProduct(index))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: require('@/assets/images/'+($setup.productIndex === index ? item.iconActive : item.icon)),
                alt: ""
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1)
          ])
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      ($setup.productIndex == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("img", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.jumpPage('/journey-to-the-west'))),
                  alt: ""
                }, null, 512), [
                  [_directive_lazy, require('@/assets/images/pc/product_xiyou.png')]
                ]),
                _withDirectives(_createElementVNode("img", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.jumpPage('/come-on-bite-me!'))),
                  class: "last-img",
                  alt: ""
                }, null, 512), [
                  [_directive_lazy, require('@/assets/images/pc/product_conglin.png')]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("img", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.jumpPage('/tailor-master'))),
                  alt: ""
                }, null, 512), [
                  [_directive_lazy, require('@/assets/images/pc/product_caif.png')]
                ]),
                _withDirectives(_createElementVNode("img", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.jumpPage('/win-or-die'))),
                  class: "last-img",
                  alt: ""
                }, null, 512), [
                  [_directive_lazy, require('@/assets/images/pc/product_wod.png')]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("img", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.jumpPage('/safari-witness'))),
                  alt: ""
                }, null, 512), [
                  [_directive_lazy, require('@/assets/images/pc/product_witness.png')]
                ]),
                _withDirectives(_createElementVNode("img", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.jumpPage('/cascading-stars'))),
                  class: "last-img",
                  alt: ""
                }, null, 512), [
                  [_directive_lazy, require('@/assets/images/pc/product_aigame.png')]
                ])
              ])
            ])
          ]))
        : ($setup.productIndex == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("img", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.jumpPage('/journey-to-the-west'))),
                    alt: ""
                  }, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/product_xiyou.png')]
                  ]),
                  _withDirectives(_createElementVNode("img", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.jumpPage('/come-on-bite-me!'))),
                    class: "last-img",
                    alt: ""
                  }, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/product_conglin.png')]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("img", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.jumpPage('/tailor-master'))),
                    alt: ""
                  }, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/product_caif.png')]
                  ]),
                  _withDirectives(_createElementVNode("img", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.jumpPage('/win-or-die'))),
                    class: "last-img",
                    alt: ""
                  }, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/product_wod.png')]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("img", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.jumpPage('/safari-witness'))),
                    alt: ""
                  }, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/product_witness.png')]
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _withDirectives(_createElementVNode("img", {
                alt: "",
                onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.jumpPage('/cascading-stars')))
              }, null, 512), [
                [_directive_lazy, require('@/assets/images/pc/product_game_banner.png')]
              ])
            ]))
    ])
  ]))
}